import * as React from 'react';
import Layout from '../components/Layout';
import OpinionsFromUsers from '../components/OpinionsFromUsers';
import BannerScheduleMeeting from '../components/BannerScheduleMeeting';
import Footer from '../components/Footer';
import Header from '../components/Header';
import LanguageSwitcher from '../components/LanguageSwitcher';
import FAQ from '../components/FAQ';
import Carousel from '../components/Carousel';
import PricingCards from '../components/PricingCards';

export default function PricingPage() {
  return (
    <Layout>
      <Header />
      <PricingCards />
      <Carousel />
      <OpinionsFromUsers />
      <BannerScheduleMeeting />
      <FAQ />
      <Footer />
      <LanguageSwitcher />
    </Layout>
  );
}